export const TENANT = "vistaprint";
